@if (useFor != 'create-multimedia-content') {
  <div>
    <ng-container *ngTemplateOutlet="uploaderBlock"></ng-container>
  </div>
}

@if (useFor == 'create-multimedia-content') {
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedExtractorTabIndex">
    <mat-tab label="{{ 'CreateChunk.Downloader' | translate }}">
      <ng-container *ngTemplateOutlet="uploaderBlock"></ng-container>
    </mat-tab>
    <mat-tab label="{{ 'CreateChunk.ImageGenerator' | translate }}">
      <div class="p-05">
        @if (loading) {
          <mat-progress-bar class="mt-1" mode="indeterminate"></mat-progress-bar>
        }
        @if (generatedImageURL) {
          <div class="image-displayer">
            <img [src]="generatedImageURL" height="500px" />
            <div class="img-gen-btn">
              @if (uploader?.queue[0]) {
                <button
                  color="primary"
                  mat-flat-button
                  (click)="uploadItem(uploader?.queue[0])"
                  [disabled]="uploader?.queue[0]?.isReady || uploader?.queue[0]?.isUploading || uploader?.queue[0]?.isSuccess || incorrectResolutionError"
                >
                  {{ 'FileUploader.Upload' | translate }}
                </button>
              }
            </div>
          </div>
        }
        @if (!generatedImageURL) {
          <div>
            <div class="image-generator-prompt">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{ 'Courses.ChunkCreator.ImageGeneratorPrompt' | translate }}</mat-label>
                <textarea [disabled]="loading" matInput [(ngModel)]="imageGenerationPrompt"></textarea>
              </mat-form-field>
            </div>
            <div class="image-generator-options">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'FileUploader.Resolution' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedResolution">
                  @for (resolution of generatedImageResolutions; track resolution) {
                    <mat-option [value]="resolution.value">
                      {{ resolution.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>{{ 'FileUploader.Style' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedStyle">
                  @for (resolution of generatedImageStyle; track resolution) {
                    <mat-option [value]="resolution.value">
                      {{ resolution.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="img-gen-btn">
              <button mat-raised-button color="primary" (click)="generateImageFromContent()" [disabled]="loading">
                {{ 'FileUploader.GenerateFromContent' | translate }}
              </button>
              <button mat-raised-button color="primary" (click)="generateImage()" [disabled]="loading">
                {{ 'MySpace.GenerateImage' | translate }}
              </button>
            </div>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
}

<ng-template #uploaderBlock>
  <div class="mb-1 mt-1">
    <div class="uploader-grid mb-1">
      @if (!uploader.queue.length) {
        <div id="uploaders" class="flex-column">
          <div ng2FileDrop [ngClass]="{ 'dz-file-over': hasBaseDropZoneOver }" [uploader]="uploader" (fileOver)="fileOverBase($event)" class="uploader-wrapper">
            <div class="dropzone-content">
              <div class="upload-icon">
                <mat-icon>upload</mat-icon>
              </div>
              <div class="text-center">
                <div class="fw-medium mb-1">{{ 'FileUploader.DropFileHere' | translate }}</div>
                <div class="text-muted small mb-2">ou</div>
              </div>
              <label for="file-upload-btn" class="custom-file-upload">
                {{ 'FileUploader.ChooseFile' | translate }}
              </label>
              <input id="file-upload-btn" type="file" ng2FileSelect [uploader]="uploader" />
            </div>
          </div>
        </div>
      }

      @if (uploader.queue.length) {
        <div id="upload-detail" class="flex-column">
          <div>
            <b>{{ 'FileUploader.Name' | translate }} :</b>
            {{ uploader.queue[0]?.file?.name }}
            <br />
            <b>{{ 'FileUploader.Type' | translate }} :</b>
            {{ uploader.queue[0]?.file?.type }}
            <br />
            <b>{{ 'FileUploader.Size' | translate }} :</b>
            {{ uploader.queue[0]?.file?.size / 1024 / 1024 | number: '.2' }} MB
            <br />
            @if (imageResolution) {
              <div [ngClass]="incorrectResolutionError ? 'red-text' : ''">
                <b>{{ 'FileUploader.Resolution' | translate }} :</b>
                {{ imageResolution.width + 'x' + imageResolution.height }}
                <br />
              </div>
            }
            <b>{{ 'FileUploader.Status' | translate }} :</b>
            <!-- en attente | en téléchargement | téléchargé | annulé |erreur -->
            @if (!inProgress && !uploader.queue[0]?.isSuccess && !uploader.queue[0]?.isCancel && !uploader.queue[0]?.isError) {
              <mat-label>{{ 'FileUploader.Ready' | translate }}</mat-label>
            }
            @if (inProgress) {
              <mat-progress-bar class="mt-1" mode="indeterminate"></mat-progress-bar>
            }
            @if (uploader.queue[0]?.isSuccess) {
              <mat-label>{{ 'FileUploader.Uploaded' | translate }}</mat-label>
            }
            @if (uploader.queue[0]?.isCancel) {
              <mat-label color="accent">{{ 'FileUploader.Cancelled' | translate }}</mat-label>
            }
            @if (uploader.queue[0]?.isError) {
              <mat-label color="warn">{{ 'FileUploader.Failed' | translate }}</mat-label>
            }
            <br />
          </div>
          <div>
            <button
              color="primary"
              mat-flat-button
              class="mr-1"
              (click)="uploadItem(uploader.queue[0])"
              [disabled]="uploader.queue[0].isReady || uploader.queue[0].isUploading || uploader.queue[0].isSuccess || incorrectResolutionError"
            >
              {{ 'FileUploader.Upload' | translate }}
            </button>
            <button mat-flat-button (click)="uploader.queue[0].remove()">
              {{ 'FileUploader.Remove' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
